import { useAuth } from "@clerk/clerk-react";
import { Veriff } from "@veriff/js-sdk";
import { Input } from "Components/ui/input";
import { Skeleton } from "Components/ui/skeleton";
import { AnimatePresence, motion } from "framer-motion";
import UseInnerWidth from "hooks/UseInnerWidth";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ProfileDatePicker from "../ProfileDatePicker/ProfileDatePicker";
import DropdownInput from "Components/DropDownInput/DropDownInput";
import TextInput from "Components/TextInput/TextInput";
import { nationalities, types } from "lib/data";
import "./Identity.scss";

function Identity({ data, setData }) {
  const { identity, user, getUserLoading } = useSelector(
    (state) => state.ProfileReducer
  );

  const width = UseInnerWidth();
  const { getToken } = useAuth();

  useEffect(() => {
    setData({
      documentType: identity?.identity?.documentType,
      dob: identity?.identity?.dob,
      nationality: identity?.identity?.nationality,
      documentNumber: identity?.identity?.documentNumber,
      files: identity?.fileObjects?.files,
    });
  }, [identity]);

  const dispatch = useDispatch();
  const veriffInstance = Veriff({
    apiKey: process.env.REACT_APP_VERIFF_API_KEY,
    parentId: "veriff-root",
    callback: `${process.env.REACT_APP_LOCAL_API}/profile`,
    onSession: function (err, response) {
      if (err) {
        console.error(err);
        return;
      }
      window.open(response.verification.url, "_blank");
    },
  });

  useEffect(() => {
    veriffInstance.setParams({
      person: {
        givenName: user?.firstName,
        lastName: user?.lastName,
      },
      vendorData: user?.id,
    });

    veriffInstance.mount({
      submitBtnText:
        user?.verificationStatus === "FAILED"
          ? "Re-Submit Your Verification"
          : "Get verified",
      loadingText: "Please wait...",
    });

    // const timer = setTimeout(() => {
    //   const submitButton = document.getElementById("veriff-submit-btn");
    //   if (submitButton) {
    //     submitButton.click();
    //   }
    // }, 300);

    // return () => clearTimeout(timer);
  }, [user]);

  return (
    <>
      <div
        className={`${
          user?.isVerified && "hidden"
        } h-[34vh]  flex flex-col bg-background-card justify-center items-center`}
      >
        <AnimatePresence initial={true} mode="wait">
          <motion.div
            exit={{
              opacity: 0,
              x: -100,
            }}
            initial={{
              opacity: 0,
              x: -100,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            id="veriff-root"
            className={
              "bg-background-card w-full" &&
              (getUserLoading || user?.isVerified) &&
              "hidden"
            }
          ></motion.div>
        </AnimatePresence>

        {getUserLoading && (
          <div className="flex flex-col items-center -translate-y-3">
            <Skeleton className="w-[10rem] sm:w-[20rem] h-10 rounded bg-primary" />
            <Skeleton className="w-[18rem] h-2 rounded-lg bg-primary mt-4" />
            <Skeleton className="w-[9rem] h-2 rounded-lg bg-primary mt-2" />
          </div>
        )}
      </div>
      {user?.isVerified && (
        <AnimatePresence initial={true} mode="wait">
          <motion.div
            exit={{
              opacity: 0,
              x: -100,
            }}
            initial={{
              opacity: 0,
              x: -100,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            className=""
          >
            <div
              className={`grid bg-background-card rounded-lg p-8 ${
                width < 768 ? "grid-cols-1" : "grid-cols-2"
              }  gap-6`}
            >
              {/* <TextInput
            label="Date of Birth"
            required={true}
            placeholder="mm/dd/yyyy"
            type="text"
            value={data.dob}
            onChange={(e) => setData({ ...data, dob: e.target.value })}
          /> */}
              <TextInput
                label="Date of Birth"
                required={true}
                placeholder="mm/dd/yyyy"
                type="text"
                value={new Date(data.dob).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
                disabled
              />
              <DropdownInput
                label={"Nationality"}
                required={true}
                placeholder={"Select Nationality"}
                value={data.nationality}
                data={nationalities}
                key={"nationalities"}
                disabled
              />
              <DropdownInput
                label={"Document Type"}
                required={true}
                placeholder={"Select Document Type"}
                value={data.documentType}
                data={types}
                key={"types"}
                disabled
              />
              <TextInput
                label="ID Number"
                required={true}
                placeholder="LR123456"
                type="text"
                value={data.documentNumber}
                disabled
              />
            </div>
          </motion.div>
        </AnimatePresence>
      )}
    </>
  );
}

export default Identity;
